'use client';

import { useState } from 'react';

import { AppDownloadModal } from '../../AppDownloadModal/AppDownloadModal';
import { Button } from '../../Clickables/Buttons/Button';
import regulationsPhone from '../assets/RegulationsPhone.png';
import regulationsPhoneMobile from '../assets/RegulationsPhoneMobile.png';

interface IProps {
  appDownloadModalTitle: string;
  appDownloadSourceId?: string;
  label?: string;
}

export const SeeMoreSpeciesCTA = ({
  appDownloadModalTitle,
  appDownloadSourceId,
  label = 'See more species',
}: IProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        size="sm"
        className="mt-2 p-2"
        variant="buttonPrimary"
        onClick={() => setIsModalOpen(true)}
      >
        {label}
      </Button>
      <AppDownloadModal
        appDownloadSource="RegulationSectionNew"
        appDownloadSourceId={appDownloadSourceId}
        modalHeader={appDownloadModalTitle}
        // modalText=""
        image={regulationsPhone}
        imageMobile={regulationsPhoneMobile}
        isModalOpen={isModalOpen}
        onCloseModal={() => setIsModalOpen(false)}
      />
    </>
  );
};
